import { Injectable } from '@angular/core';

import { NotificationPosition } from '../models/notification.model';
import { NotificationService } from './notification.service';
import { TranslateService } from '../translate/translate.service';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  constructor(
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  public showFilesRemovedWarning(excludedFiles: File[]): void {
    const maxFileNamesToDisplay: number = 5;
    const mapFileName = (fileToMap: File): string => {
      return fileToMap.name;
    };
    let excludedFileNames: string = excludedFiles.map(mapFileName).join(', ');

    if (excludedFiles.length > maxFileNamesToDisplay) {
      excludedFileNames += ', ...';
    }

    this.notificationService.warn(
      this.translateService.instant('some_attached_files_were_removed', [excludedFileNames]),
      NotificationPosition.Toast,
    );
  }
}
